var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseElementRenderer } from './base_element_renderer';
var DropDownRenderer = /** @class */ (function (_super) {
    __extends(DropDownRenderer, _super);
    function DropDownRenderer(slot) {
        return _super.call(this, slot) || this;
    }
    DropDownRenderer.prototype.showEditor = function () {
        var _this = this;
        var menu = this.getMenu();
        if (menu) {
            menu.showMenu({
                anchor: this.labelElement,
                itemSelectedCallback: function (item) {
                    _this.itemSelected(item.id);
                    return false;
                }
            });
        }
    };
    DropDownRenderer.prototype.closeEditor = function () {
        var menu = this.getMenu();
        if (menu)
            menu.hideMenu();
    };
    return DropDownRenderer;
}(BaseElementRenderer));
export { DropDownRenderer };
//# sourceMappingURL=dropdown_renderer.js.map